import { SitePlan } from "./modules/MarkerMap/SitePlan.js";

// Import styles (immer)
import '../Scss/styles.scss';

// Swiper-Styles global laden (nicht im Modul)
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const cleanupFunctions = [];

function initializeModules() {

  const mapContainer = document.querySelector('.container-map');
    
  if(mapContainer){

  const mapDiv = document.getElementById("marker-map-data");


  let markerData = [];
  const jsonTag = document.getElementById('marker-map-data-json');
  if (jsonTag && jsonTag.textContent) {
      try { markerData = JSON.parse(jsonTag.textContent); } catch (e) { console.error('Invalid marker JSON', e); }
  } else if (mapDiv && mapDiv.dataset.marker) {
      try { markerData = JSON.parse(mapDiv.dataset.marker); } catch (e) { console.error('Invalid marker data attribute JSON', e); }
  }
  
  let sp = new SitePlan();
      sp.setMarker(markerData);

  }




  const modules = [
    {
      selector: 'body',
      name: 'Scroll To Top',
      hasCleanup: false,
      loader: () => import('./modules/scrollToTop.js'),
      exportName: 'initScrollToTop',
    },
    {
      selector: '.burger-btn',
      name: 'Burger Menu',
      hasCleanup: false,
      loader: () => import('./modules/burger-menu.js'),
      exportName: 'initBurgerMenu',
    },
    {
      selector: '.winefestival-header',
      name: 'Mobile Header Scroll Toggle',
      hasCleanup: true,
      loader: () => import('./modules/mobileHeaderScrollToggle.js'),
      exportName: 'initMobileHeaderScrollToggle',
    },
    {
      selector: '[data-accordion]',
      name: 'Accordion',
      hasCleanup: true,
      loader: () => import('./modules/accordion.js'),
      exportName: 'initAccordions',
    },
    {
      selector: '.swiper, .gallery-slider',
      name: 'Swiper Container',
      hasCleanup: true,
      loader: () => import('./modules/swiperContainer.js'),
      exportName: 'initSwiperContainer',
    },
    {
      selector: '.number-item',
      name: 'Numbers',
      hasCleanup: false,
      loader: () => import('./modules/numbers.js'),
      exportName: 'initNumbers',
    },
    {
      selector: '.tx-powermail form.powermail_form',
      name: 'Powermail Validation',
      hasCleanup: false,
      loader: () => import('./modules/validation.js'),
      exportName: 'initPowermailValidation',
    },
    {
      selector: '.tx-powermail input.powermail_date',
      name: 'Powermail Date Picker',
      hasCleanup: false,
      loader: () => import('./modules/powermailDatePicker.js'),
      exportName: 'initPowermailDatePicker',
    },
    {
      selector: '.countdown',
      name: 'Countdown',
      hasCleanup: true,
      loader: () => import('./modules/countdown.js'),
      exportName: 'initCountdown',
    },
    {
      selector: '[data-contact-form-tabs]',
      name: 'Contact Form Tabs',
      hasCleanup: false,
      loader: () => import('./modules/contactFormTabs.js'),
      exportName: 'initContactFormTabs',
    },
    {
      selector: '#app',
      name: 'winzer slider',
      hasCleanup: false,
      loader: () => import('./modules/winzer/winzer-slider.js'),
      exportName: 'init',
    },
    {
      selector: '#anbaugebiete',
      name: 'anbaugebieter slider',
      hasCleanup: false,
      loader: () => import('./modules/winzer/anbaugebiete-slider.js'),
      exportName: 'init',
    }
  ];

  modules.forEach((moduleConfig) => {
    if (!document.querySelector(moduleConfig.selector)) {
      return;
    }

    moduleConfig
      .loader()
      .then((mod) => {
        const initFn = mod[moduleConfig.exportName];
        if (typeof initFn !== 'function') {
          return;
        }

        const result = moduleConfig.initArgs ? initFn(...moduleConfig.initArgs) : initFn();
        if (moduleConfig.hasCleanup && typeof result === 'function') {
          cleanupFunctions.push(result);
        }
      })
      .catch((error) => {
        console.error(`Error initializing ${moduleConfig.name}:`, error);
      });
  });
}

function cleanup() {
  cleanupFunctions.forEach((fn) => {
    try {
      fn();
    } catch (error) {
      console.error('Error during cleanup:', error);
    }
  });
  cleanupFunctions.length = 0;
}

function updateScrollableClass() {
  document.documentElement.classList.toggle(
    'is-scrollable',
    document.documentElement.scrollHeight > window.innerHeight
  );
}

document.addEventListener('DOMContentLoaded', () => {
  initializeModules();
  updateScrollableClass();
  new ResizeObserver(updateScrollableClass).observe(document.documentElement);
});

window.addEventListener('beforeunload', cleanup);
